<template>
    <div>
        <div class="panel-item-wrap" @click="handleCli">
            <div class="panel-image">
                <img :src="item.user_icons[0]" class="left-top">
                <img :src="item.user_icons[1]" class="right-top">
                <img :src="item.user_icons[2]" class="left-bottom">
                <img :src="item.user_icons[3]" class="right-bottom">
            </div>
            <div class="panel-info">
                <div class="panel-game-info">
                    <div v-if="!isShopDrawer" class="panel-info-title">{{ title }}</div>
                    <div v-if="isShopDrawer" class="panel-info-title">{{ tbName }}</div>
                    <div v-if="isShopDrawer" class="panel-info-blue-point"></div>
                    <div v-if="isShopDrawer" class="panel-info-state">{{ item.last_vague_time }}</div>
                </div>
                <div v-if="isShopDrawer" class="panel-tieba-info">
                    <div v-if="item.follow_num" class="tieba-joined-num">{{ item.follow_num }}玩家</div>
                    <div v-if="item.follow_num && item.discuss_num" class="tieba-info-line"></div>
                    <div v-if="item.discuss_num" class="tieba-info-post-num">{{ item.discuss_num }}讨论</div>
                </div>
                <div
                    v-if="chat && !isShopDrawer"
                    :class="['panel-info-chat', animStart ? 'panel-info-chat-anim' : '']"
                >
                    <div class="detail" :style="{'max-width': item.has_btn === 0 ? '53.7vw' : '37.7vw'}">
                        {{ chat.title }}
                    </div>
                    <div class="num flex-style">
                        <img :src="like">
                        <span>{{ chat.agree_num }}</span>
                    </div>
                </div>
            </div>
            <div v-if="item.has_btn && item.has_btn === 1 && !isShopDrawer" class="panel-btn flex-style">
                {{ item.btn_txt }}
            </div>
            <div
                v-if="isShopDrawer"
                class="panel-btn flex-style"
                :style="{background: 'rgba(51,136,255,0.09)'}"
                @click.stop="toFrsPage"
            >
                加入
            </div>
            <img
                v-if="!isShopDrawer"
                :src="close"
                class="panel-close"
                @click.stop="closePanel"
            >
        </div>
        <div
            v-if="isShopDrawer" class="shop-panel-info"
            @click="handleCli"
        >
            <div
                v-if="chat"
                :class="['shop-panel-info-chat', animStart ? 'shop-panel-info-chat-anim' : '']"
            >
                <div class="detail" :style="{'max-width': '70.7vw'}">{{ chat.title }}</div>
                <div class="num flex-style">
                    <img :src="like">
                    <span>{{ chat.agree_num }}</span>
                </div>
            </div>
        </div>
        <div
            v-if="isShopDrawer && thirdStoreInfo.is_show_four_element === 1"
            class="panel-bottom-line"
        >
        </div>
        <div
            v-if="!isShopDrawer || (isShopDrawer && thirdStoreInfo.is_show_four_element === 1)"
            class="tieba-elements" :style="{'margin-bottom': isShopDrawer ? '0.5vh' : ''}"
        >
            <div v-if="item.tieba_pack_info && !isIOS" class="panel-bottom-firm">
                <div class="firm">{{ item.tieba_pack_info.dev }}</div>
            </div>
            <div v-if="item.tieba_pack_info && !isIOS" class="panel-bottom-right">
                <div class="edition">v{{ item.tieba_pack_info.version }}</div>
                <div class="privacy">
                    <!-- eslint-disable-next-line max-len -->
                    <span @click.stop="jumpPage(item.tieba_pack_info.privacy)">隐私</span>和<span @click.stop="jumpPage(item.tieba_pack_info.permission)">权限</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import close from 'public/assets/imgs/float-panel-close.png';
import like from 'public/assets/imgs/like.png';
import {generateToken} from '@/utils/tiebaUtility';
import {copy, isIOS} from '@/utils/browser';
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
export default {
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        isShopDrawer: {
            type: Boolean,
            default: false,
        },
        appDetail: {
            type: Object,
            default: () => {},
        },
        thirdStoreInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            close: close,
            like: like,
            count: 0,
            animStart: false,
            isIOS: isIOS(),
        };
    },
    computed: {
        tbName() {
            const name = this.item.forum_name;
            if (!name) {
                return '';
            }
            if (name.length <= 5 || this.item.has_btn === 0) {
                return name;
            }
            return name.substr(0, 2) + '...' + name.substr(-2);
        },
        chatIndex() {
            const len = this.item.tieba_threads?.length;
            if (!len) {
                return 0;
            }
            this.triggerAnim();
            return this.count % len;
        },
        chat() {
            return this.item.tieba_threads[this.chatIndex] || null;
        },
        title() {
            return this.tbName + this.item.left_title + this.item.right_title;
        },
    },
    created() {
        this.$root.isShowFourElements = this.thirdStoreInfo?.is_show_four_element || '';
        setInterval(() => {
            this.count++;
        }, 3000);
        this.$root.sendLog('display', this.item.has_btn === 0 ? 'JoinPage_display' : 'JoinPage_display_has_btn');
    },
    methods: {
        jumpPage(url) {
            setTimeout(() => {
                location.href = url;
            }, 200);
        },
        closePanel() {
            this.$root.isShowTbFloatPanel = false;
        },
        triggerAnim() {
            this.animStart = true;
            setTimeout(() => {
                this.animStart = false;
            }, 600);
        },
        handleCli() {
            const token = this.getToPbken();
            copy(token);
            this.$root.sendLog('click', this.isShopDrawer ? 'CarouselClick'
                : this.item.has_btn === 0 ? 'JoinButton_click' : 'JoinButton_click_has_btn');
            setTimeout(() => {
                this.$emit('handleCli', '', this.chat, token);
            }, 100);
        },
        getToPbken() {
            const tid = this.item.tieba_threads?.[this.chatIndex]?.tid || '';
            const config = {
                page: 'pb',
                param: {
                    tid: tid,
                    extdata: {}, // 新schema打点
                    track: '', // fe打点
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
        getToFrsken() {
            const config = {
                page: 'frs',
                param: {
                    kw: this.appDetail.join_community_info?.forum_name || '',
                    fid: this.appDetail.join_community_info?.forum_id || '',
                    extdata: {}, // 新schema打点
                    track: '', // fe打点
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
        // 应用商店按钮跳转frs页
        toFrsPage() {
            this.$root.sendLog('click', 'AddBtnClick');
            const token = this.getToFrsken();
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'frs',
                    param: {
                        obj_source: 'wise',
                        kw: this.appDetail.join_community_info?.forum_name || '',
                        fid: this.appDetail.join_community_info?.forum_id || '',
                        locate: 'outer_game_joinsq',
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.thirdStoreInfo.join_url,
                });
            });
        },
    },
};

</script>

<style lang="scss" scoped>
@import "~@/common/style/mixin/utils";
.flex-style {
    display: flex;
    align-items: center;
    justify-content: center;
}
.panel-item-wrap {
    padding: 45px 51px 0 51px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;
    .panel-image {
        margin-right: 26px;
        width: 164px;
        height: 164px;
        position: relative;
        img {
            width: 93px;
            height: 93px;
            border: 3px solid rgba(255,255,255,1);
            border-radius: 50%;
            position: absolute;
        }
        .left-top {
            left: 0;
            top: 0;
            z-index: 99;
        }
        .right-top {
            right: 0;
            top: -2px;
            z-index: 88;
        }
        .left-bottom {
            left: 0;
            bottom: 0;
        }
        .right-bottom {
            right: 0;
            bottom: 0;
            z-index: 77;
        }
    }
    .panel-info {
        .panel-game-info {
            display: flex;
            align-items: center;
            .panel-info-title {
                font-size: 48px;
                font-weight: 500;
                margin-bottom: 10px;
                @include line-clamp1;
            }
            .panel-info-blue-point {
                width: 12px;
                height: 12px;
                background: #3388FF 100%;
                border-radius: 50%;
                margin: 0 13px 0 12px;
                margin-bottom: 10px;
            }
            .panel-info-state {
                font-family: PingFangSC-Regular;
                font-size: 36px;
                color: #3388FF;
                margin-bottom: 10px;
                font-weight: 400;
            }
        }
        .panel-tieba-info {
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular;
            font-size: 39px;
            color: #1F1F1F;
            font-weight: 400;
            margin-top: 6px;
            .tieba-joined-num {
                opacity: 0.5;
            }
            .tieba-info-line {
                width: 3px;
                height: 27px;
                opacity: 0.36;
                background: #1F1F1F;
                border-radius: 2px;
                margin: 0 12px;
            }
            .tieba-info-post-num {
                opacity: 0.5;
            }
        }
        &-chat {
            font-size: 39px;
            color: #858585;
            font-weight: 400;
            display: flex;
            user-select: none;
            &-anim {
                position: relative;
                animation: anim .2s linear;
            }
            .detail {
                margin-right: 24px;
                @include line-clamp1;
            }
            .num {
                img {
                    width: 39px;
                    margin-right: 10px;
                }
            }
            @keyframes anim {
                0% {
                    opacity: 0.5;
                    bottom: -20px;
                }
                100% {
                    opacity: 1;
                    bottom: 0;
                }
            }
        }
    }
    .panel-btn {
        margin-left: auto;
        width: 192px;
        height: 93px;
        line-height: 45px;
        background: #EFF6FF;
        font-size: 45px;
        color: #3388FF;
        font-weight: 400;
        border-radius: 46.5px;
    }
    .panel-close {
        position: absolute;
        top: 40px;
        right: 30px;
        width: 30px;
        height: 30px;
    }
}
.shop-panel-info {
    margin: 36px 0 0 42px;
    &-title {
        font-size: 48px;
        font-weight: 500;
        margin-bottom: 10px;
        @include line-clamp1;
    }
    &-chat {
        font-size: 39px;
        color: #858585;
        font-weight: 400;
        display: flex;
        user-select: none;
        &-anim {
            position: relative;
            animation: anim .2s linear;
        }
        .detail {
            margin-right: 24px;
            @include line-clamp1;
        }
        .num {
            img {
                width: 39px;
                margin-right: 10px;
            }
        }
        @keyframes anim {
            0% {
                opacity: 0.5;
                bottom: -20px;
            }
            100% {
                opacity: 1;
                bottom: 0;
            }
        }
    }
}
.panel-bottom-line {
    width: 1056px;
    height: 1px;
    opacity: 0.08;
    border: 2px solid rgba(31,31,31,1);
    margin: 35px;
}
.tieba-elements {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 51px;
    box-sizing: border-box;
    padding-bottom: 21px;
    box-sizing: border-box;
    .panel-bottom-firm {
        font-family: PingFangSC-Regular;
        font-size: 33px;
        color: #A8A8A8;
        font-weight: 400;
    }
    .panel-bottom-right {
        font-family: PingFangSC-Regular;
        font-size: 33px;
        color: #A8A8A8;
        font-weight: 400;
        display: flex;
        align-items: center;
        .edition {
            margin-right: 10px;
        }
        .privacy {
            margin-left: auto;
            z-index: 1001;
            span {
                text-decoration: underline;
            }
        }
    }
}
</style>